import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import FormStepsDisplay from './_partials/FormStepsDisplay';
import FirstStep from './_partials/FirstStep';
import SecondStep from './_partials/SecondStep';
import CoverImageField from './fields/CoverImageField';

import s from './CustomExclusivePopup.scss';

const FINAL_STEP = 2;

interface Props {
  onRequestClose: () => void;
}

const CustomExclusivePopup: React.FC<Props> = ({ onRequestClose }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);

  const formContext = useForm({
    mode: 'onSubmit',
    defaultValues: {
      deliveryTime: 7,
      displayResolution: 'original',
      addWatermark: false,
    },
  });

  const handleContinueClick = useCallback(() => {
    setStep(step + 1);
  }, [step]);

  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      heading={t('customExclusivePopup.heading')}
      subheading={<FormStepsDisplay currentStep={step} />}
      contentClassName={s['modal-content']}
      withScrollableContentWrapper={false}
      showHeaderBorder
      showFooterBorder
      footerRight={[
        <TextButton
          key="cancel"
          variant="main"
          size="medium"
          onClick={onRequestClose}
        >
          {t('common.cancel')}
        </TextButton>,
        step === FINAL_STEP ? (
          <BrandedButton
            key="confirm"
            variant="brand-green"
            size="medium"
            onClick={onRequestClose}
          >
            {t('common.submit')}
          </BrandedButton>
        ) : (
          <BrandedButton
            key="confirm"
            variant="brand-green"
            size="medium"
            onClick={handleContinueClick}
          >
            {t('common.continue')}
          </BrandedButton>
        ),
      ]}
    >
      <FormProvider {...formContext}>
        <div className={s['main-area']}>
          {step === 1 && <FirstStep />}
          {step === 2 && <SecondStep />}
        </div>
        <div className={s['preview-area']}>
          <CoverImageField />
        </div>
      </FormProvider>
    </Modal>
  );
};
CustomExclusivePopup.displayName = 'CustomExclusivePopup';

export default CustomExclusivePopup;
